import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {} from 'react'
import {useFragment} from 'react-relay'

import {cardShadow} from '../styles/elevation'
import TimelineEventDate from './TimelineEventDate'
import TimelineEventHeaderMenuToggle from './TimelineEventHeaderMenuToggle'
import TimelineEventTypeIcon from './TimelineEventTypeIcon'










const Surface = styled('div')({
  background: '#FFFFFF',
  borderRadius: 4,
  boxShadow: cardShadow,
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 16,
  overflow: 'hidden',
  position: 'relative',
  width: '100%'
})

const CardHeader = styled('div')({
  display: 'flex',
  margin: '16px 16px 8px',
  position: 'relative',
  justifyContent: 'space-between'
})

const CardTitleBlock = styled('div')({
  display: 'flex'
})

const HeaderText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 14,
  justifyContent: 'space-around',
  lineHeight: '20px',
  paddingLeft: 16,
  paddingTop: 2
})

const TimelineEventCard = (props) => {
  const {children, iconName, IconSVG, title, timelineEvent: timelineEventRef} = props
  const timelineEvent = useFragment(
    graphql`
      fragment TimelineEventCard_timelineEvent on TimelineEvent {
        id
        createdAt
        type
      }
    `,
    timelineEventRef
  )
  const {id: timelineEventId, createdAt, type} = timelineEvent
  return (
    React.createElement(Surface, null
      , React.createElement(CardHeader, null
        , React.createElement(CardTitleBlock, null
          , React.createElement(TimelineEventTypeIcon, { iconName: iconName,} )
          , IconSVG
          , React.createElement(HeaderText, null
            , title
            , React.createElement(TimelineEventDate, { createdAt: createdAt,} )
          )
        )
        , type === 'retroComplete' ||
        type === 'actionComplete' ||
        type === 'POKER_COMPLETE' ||
        type === 'TEAM_PROMPT_COMPLETE' ? (
          React.createElement(TimelineEventHeaderMenuToggle, { timelineEventId: timelineEventId,} )
        ) : null
      )
      , children
    )
  )
}

export default TimelineEventCard
